import { connect } from 'react-redux';
import { fetchRules, updateRules, deleteRule, createRule, updateKeyRule } from '../../actions/index';
import Audit from '../../components/Audit/Audit';

const mapStateToProps = state => {
    return {
        rules: state.rules,
        ruleDeleting: state.ruleDeleting ,
        invalidWorktags: state.validateWorkTags,
        ruleSubmitting: state.ruleSubmitting
    }
};

export default connect(
    mapStateToProps,
    { fetchRules, updateRules, deleteRule, createRule, updateKeyRule }
)(Audit);


// WEBPACK FOOTER //
// ./src/containers/Audit/AuditContainer.js